import { useState } from "react";
import PropTypes from "prop-types";
import { Snackbar, Alert, TextField, Box, InputAdornment, Icon } from "@mui/material";

function BVNField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);

  return (
    <Box>
      <TextField
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const bvn = e.target.value;
          const isnum = /^\d+$/.test(bvn);
          if (!isnum || bvn.length !== 11) {
            e.target.value = null;
            showFieldError(true);
          }
        }}
        options={options}
        InputProps={{
          startAdornment: <InputAdornment position="start"><Icon>lock</Icon></InputAdornment>,
        }}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          Invalid BVN provided.
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Typechecking props of the Transaction
BVNField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

BVNField.defaultProps = {
  options: null,
};

export default BVNField;
